import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { FaSearch } from 'react-icons/fa';
import { Form } from "react-bootstrap";
import PatientModel from "../../models/patient";
import { DataTable } from "../../components";
import { PatientInterface } from "../../interfaces";

const ViewPatients = () => {
  const navigate = useNavigate();

  const [patients, setPatients] = useState<PatientInterface[]>([]);
  const [entryScope, setEntryScope] = useState<'prod' | 'test'>('prod');

  const [totalCount, setTotalCount] = useState(0);
  const [pagination, setPagination] = useState({ pageIndex: 0, pageSize: 15 });
  const [search, setSearch] = useState('');
  const [isLoading, setIsLoading] = useState(false);
  

  const goToPatientProfile = (patientId: string) => {
    navigate(`/profile/${patientId}`);
  };

  const fetchPatients = async (pageIndex: number, pageSize: number) => {
    try {
      setIsLoading(true);
      const skip = pageIndex * pageSize;

      const query = {
        $skip: skip,
        $limit: pageSize,
        $sort: { createdAt: -1 },
        test: { $ne: true },
        ...(search && {
          $or: [
            { firstName: { $regex: `(?i).*${search}.*` } },
            { lastName: { $regex: `(?i).*${search}.*` } },
            { email: { $regex: `(?i).*${search}.*` } },
          ],
        }),
      };

      if(entryScope === 'prod') {
        Object.assign(query, { test: { $ne: true } });
      } else if(entryScope === 'test') {
        Object.assign(query, { test: true });
      }

      const resp = await PatientModel.fetchAll<any>(query);

      return {
        rows: resp.data.filter((item: any) => item.email),
        totalCount: resp.total,
      };
    } catch (error: any) {
      throw new Error(error.message);
    } finally {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    fetchPatients(pagination.pageIndex, pagination.pageSize).then((res) => {
      setPatients(res.rows);
      setTotalCount(res.totalCount);
    });
  }, [pagination]);


  return (
    <div>
      <div className="d-flex align-items-center mb-3 gap-3">
        <div className="input-group w-25">
          <span className="input-group-text">
            <FaSearch color='#3ca2ab'/>
          </span>
          <input
            type="text"
            className="form-control"
            placeholder="Search..."
            onChange={(e:any) => {
              setSearch(e.target.value);
              setPagination({ pageIndex: 0, pageSize: pagination.pageSize });
            }}
          />
        </div>

        <Form.Select
          className="w-25"
          value={entryScope}
          onChange={(e) => {
            setEntryScope((e.target.value) as 'prod' | 'test');
            setPagination({ pageIndex: 0, pageSize: pagination.pageSize });
          }}
        >
          <option value="prod">Production Entries</option>
          <option value="test">Test Entries</option>
        </Form.Select>
      </div>

      <DataTable 
        columns={PatientModel.getColumns()} 
        onRowClick={(row) => goToPatientProfile(row.original._id)} 
        data={patients}
        pagination={pagination}
        onPaginationChange={setPagination}
        totalRowCount={totalCount}
        loading={isLoading}
      />
    </div>
  );
};

export default ViewPatients;
